// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Hom/Home";
import Navbar from "./Compments/Navbar";
import LoginRegister from "./Admin/loginRegister";
import Dashboard from "./Admin/DashboardPanel";
import ArticlePage from "./Compments/ArticlePage";
// 🆕 ΝΕΟ: Εισαγωγή του ArchivePage
import ArchivePage from "./Compments/ArchivePage";
 // Υποθέτω ότι το έβαλες στα Compments, αλλιώς διόρθωσε το path
 import EventPage from "./Pages/Hom/EventsPage";
 import EventsArchive from "./Pages/Hom/EventsArchive";
import AboutPage from "./Pages/Hom/About";
import TestimonialPage from "./Pages/Hom/ΤestimonialPage";
function App() {
  return (
    <Router>
      <Navbar />
      <div className="p-6 max-w-6xl mx-auto">
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Διαδρομή Σελίδας Άρθρου */}
<Route path="/articles/:slug" element={<ArticlePage />} />

          {/* 🆕 ΝΕΕΣ ΔΙΑΔΡΟΜΕΣ ΑΡΧΕΙΟΥ (ArchivePage) */}
          {/* 1. Όλα τα Άρθρα: /archive */}
          <Route path="/archive" element={<ArchivePage />} /> 

          {/* 2. Άρθρα ανά Κατηγορία: /archive/Music */}
          <Route path="/archive/:category" element={<ArchivePage />} /> 

          {/* 3. Άρθρα ανά Κατηγορία & Είδος: /archive/Music/Rock */}
          <Route path="/archive/:category/:genre" element={<ArchivePage />} />

          <Route path="/Pulse_of_the_underground/About" element={<AboutPage />} />

           <Route path="/Pulse_of_the_underground/Editorial-Team" element={<TestimonialPage />} />

          {/* Διαδρομές Διαχείρισης (Admin) */}
          <Route path="/user/stuff/POU_content_managment" element={<LoginRegister />} />
          <Route path="/user/stuff/dashboard" element={<Dashboard />} />
          <Route path="/Pulse_Of_The_Underground/events" element={<EventsArchive />} />     
          <Route path="/events/:id" element={<EventPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;